import loadable from '@loadable/component';

import { createPlugin } from '@backstage/core-plugin-api';

import { createWorkflowExtension } from '@spotify/plugin-confidence-workflows-react';

import { AbTestTableRow } from './components';
import { AbTestIcon } from './components/AbTestIcon';
import { AB_TEST_WORKFLOW_ID } from './constants';

export const confidenceWorkflowsModuleAbTestPlugin = createPlugin({
  id: 'confidence-workflows-module-ab-test',
});

const componentsChunk = () =>
  import(
    /* webpackChunkName: "workflows-ab-test-pages", webpackPrefetch: 5 */ './components'
  );
const loadOptions = {};

const AbTestWorkflowPage = loadable(
  () => componentsChunk().then(m => m.AbTestWorkflowPage),
  loadOptions,
);
const AbTestWorkflowInstancePage = loadable(
  () => componentsChunk().then(m => m.AbTestWorkflowInstancePage),
  loadOptions,
);
const CreateAbTest = loadable(
  () => componentsChunk().then(m => m.CreateAbTest),
  loadOptions,
);
const AbTestOpenGraph = loadable(
  () => componentsChunk().then(m => m.AbTestOpenGraph),
  loadOptions,
);

export const ABTestWorkflowExtension =
  confidenceWorkflowsModuleAbTestPlugin.provide(
    createWorkflowExtension({
      title: 'A/B test',
      workflowId: AB_TEST_WORKFLOW_ID,
      workflowPage: () => <AbTestWorkflowPage />,
      workflowInstancePage: () => <AbTestWorkflowInstancePage />,
      workflowTableRowComponent: AbTestTableRow,
      workflowIcon: AbTestIcon,
      createComponent: overrides => <CreateAbTest overrides={overrides} />,
      openGraphComponent(name) {
        return <AbTestOpenGraph name={name} />;
      },
    }),
  );
